import React, {useCallback, MouseEventHandler} from 'react'
import {useState, useEffect} from 'react'
import Dropzone from 'react-dropzone-uploader'
import {useDropzone} from 'react-dropzone'
import Tooltip from '@mui/material/Tooltip'
import 'react-dropzone-uploader/dist/styles.css'
import AddIcon from '@mui/icons-material/Add'
import IconButton from '@mui/material/IconButton'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'

import {useFormik} from 'formik'
import * as Yup from 'yup'
import {MDBCard, MDBCardBody, MDBCol, MDBInput, MDBRow, MDBTextArea} from 'mdb-react-ui-kit'

import {Get_Doc_List, Upload_Doc, Upload_Img, ShowDoc, ShowImg, DisplyImg} from './Property_Api'

import {makeStyles} from '@material-ui/core/styles'
import {promises} from 'stream'
import '../superAdmin/common/styles.css'
import {display} from '@mui/system'
const LOCAL_URL = process.env.REACT_APP_LOCALHOST

const useStyles = makeStyles({
  propertyGallery: {
    width: '70%',
    margin: 'auto',
    padding: '30px',
    borderRadius: '10px',
    height: 'auto',
    backgroundColor: 'red',
  },
  thumbnail: {
    width: '120px',
    height: '120px',
    cursor: 'pointer',
    margin: '10px',
    '&:hover': {
      opacity: 0.7,
    },
  },
  docForm: {
    backgroundColor: '',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0px',
  },
})
const initialValues = {}

interface FileMeta {
  name: string
  size: number
  type: string
}

interface UploadedFile {
  meta: {
    name: string
    size: number
    type: string
  }
  remove: () => void
}

interface Props {}

interface Doc {
  property_document_type_uuid: string
  property_document_type_name: string
}
interface DocList {
  document_label: string
  document_path: string
  property_document_type_name: string
  property_document_uuid: string
}

interface ImgList {
  property_id: string
  property_image_id: string
  property_image_path: String
  property_image_status: number
  property_image_uuid: string
}

const Add_PropertyDocs: React.FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [files, setFiles] = useState<File | null>(null)
  const [open, setOpen] = useState(false)
  const [visible, setVisible] = useState(false)
  const [name, setName] = useState<string | null>(null)
  const [getDoc, setGetDOc] = useState<Doc[]>([])
  const [docType, setDocType] = useState('')
  const [imgUpload, setImgUpload] = useState<File | null>(null)

  const [previewDoc, setPreviewDoc] = useState<DocList[]>([])
  const [priviewImg, setPreviewImg] = useState<ImgList[]>([])
  const [imageList, setImgeList] = useState(false)
  const [docList, setDocList] = useState(false)
  const [selectedFile, setSelectedFile] = useState<File | null>(null)

  const classes = useStyles()

  let property_id = localStorage.getItem('property_id') || ''
  const LOCAL_URL = process.env.REACT_APP_PREVIEW
  const DISPLAY_IMAGE = `${LOCAL_URL}/static/uploads/property_img/`

  // set document upload
  const handleFileChange = (event: any) => {
    setFiles(event.target.files[0])
  }

  //set name of document
  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value)
  }
  // document type
  const handleDocChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDocType(event.target.value)
  }

  //set image to state
  const handleImageUpload = (event: any) => {
    setSelectedFile(event.target.files[0])
  }

  // function to upload image
  async function handleUploadImage(e: any) {
    e.preventDefault()
    setImgeList(false)
    console.log('selectedFile>>>>>>>' + selectedFile)
    if (!selectedFile) {
      return
    }

    const reader = new FileReader()
    reader.readAsBinaryString(selectedFile)
    reader.onload = async () => {
      const base64String = btoa(reader.result as string)
     
      const res = await Upload_Img(property_id, base64String)

      if (res.data.code == 200) {
        Swal.fire({
          title: 'Added Successfully',
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        }).then(async () => {
          setOpen(false)
          setImgUpload(null)
          const result = await ShowImg(property_id)
          setPreviewImg(result.data.data)
          setImgeList(true)
        })
      } else {
        Swal.fire({
          icon: 'error',
          title: res.data.msg_details,
          showClass: {
            popup: 'animate__animated animate__fadeInDown',
          },
          hideClass: {
            popup: 'animate__animated animate__fadeOutUp',
          },
        }).then(async () => {
          setOpen(false)
          setImgUpload(null)
          const result = await ShowImg(property_id)
          setPreviewImg(result.data.data)
          setImgeList(true)
        })
      }
    }
  }

  // function to upload document to server
  async function handleUpload(e: any) {
    e.preventDefault()
    if (!files) {
      return
    }
    const reader = new FileReader()
    reader.readAsBinaryString(files)

    reader.onload = async () => {
      const base64String = reader.result != null ? btoa(reader.result as string) : ''
      try {
        const res = await Upload_Doc(docType, name, property_id, base64String)
        console.log(res.data)
        if (res.data.code == 200) {
          Swal.fire({
            title: 'Added Successfully',
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          }).then(async () => {
            setDocList(true)
            let doc = await ShowDoc(property_id)
            console.log('doc', doc.data.data)
            setPreviewDoc(doc.data.data)
            setVisible(false)
            setSelectedFile(null)
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data.msg_details,
            showClass: {
              popup: 'animate__animated animate__fadeInDown',
            },
            hideClass: {
              popup: 'animate__animated animate__fadeOutUp',
            },
          }).then(async () => {
            setDocList(true)
            setOpen(false)
            setImgUpload(null)
            let doc = await ShowDoc(property_id)
            console.log('doc', doc.data.data)
          })
        }
      } catch (err) {
        console.error(err)
      }
    }
  }


  // receives array of files that are done uploading when submit button is clicked
  const handleSubmit = (files: UploadedFile[], allFiles: UploadedFile[]) => {
    // event.preventDefault();
    console.log('rrf', files)

    //  handleUpload(files)
    // handleUploadImage(files)

    Swal.fire({
      title: 'Added Successfully',
      showClass: {
        popup: 'animate__animated animate__fadeInDown',
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp',
      },
    }).then(() => {
      setVisible(false)
      setOpen(false)
    })
  }

  function show() {
    setOpen(!open)
    setVisible(false)
  }

  function showDOc() {
    setVisible(!open)
    setOpen(false)
  }

  const docs = Yup.object().shape({})

  const formik = useFormik({
    initialValues,
    validationSchema: docs,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setLoading(true)
    },
  })

  async function getDocument() {
    const {data: res} = await Get_Doc_List()
    console.log(res.data)
    let responseData = res.data as Doc[]
    setGetDOc(responseData)
  }

  useEffect(() => {
    getDocument()
  }, [])

  function handleSkip() {
    // Swal.fire({
    //   title: 'New Property Added Successfully',
    //   showClass: {
    //     popup: 'animate__animated animate__fadeInDown',
    //   },
    //   hideClass: {
    //     popup: 'animate__animated animate__fadeOutUp',
    //   },
    // }).then((result) => {
    //   if (result.isConfirmed) {
    window.location.reload()
    //   }
    // })
  }
  return (
    <>
      <form
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        noValidate
        id='kt_login_signin_form'
        //onSubmit={formik.handleSubmit}
      >
        <MDBRow>
          <MDBCol md='10' className='mb-4'>
            <MDBCard className='mb-4'>
              <MDBCardBody>
                {formik.status && (
                  <div className='mb-lg-15 alert alert-danger'>
                    <div className='alert-text font-weight-bold'>{formik.status}</div>
                  </div>
                )}
                <MDBRow className='mb-4'>
                  <div className='error'> {} </div>
                </MDBRow>

                <MDBRow>
                  {' '}
                  <MDBCol className='form-label fw-bolder text-dark fs-6'>
                    <div className=' w-1  mt-8'>
                      {/* <Tooltip title="Add Image">
  <IconButton onClick ={show}  >
  <AddIcon  />
  </IconButton>
  </Tooltip> */}
                      <input
                        type='button'
                        value='Add Image'
                        className='btn btn-light-primary'
                        onClick={show}
                      />
                    </div>
                    <MDBRow className='mb-4 mt-10'>
                      {open ? (
                        <>
                          {/* 




                               <Dropzone  onChangeStatus={handleChangeStatus}
                                onSubmit={handleSubmit} 
                                accept="image/*"/>
      {/* <div>
        {uploadedImages.map((imageUrl) => (
          <img key={imageUrl} src={imageUrl} alt="Uploaded" />
        ))}
      </div> */}

                          <div className='mb-1 '>
                            <span className='font-css top' style={{marginLeft: '180px'}}>
                              {' '}
                              Image{' '}
                            </span>
                            <div className='' style={{marginLeft: '180px'}}>
                              <input
                                type='file'
                                onChange={handleImageUpload}
                                accept='image/*'
                                style={{
                                  padding: '2px',
                                  backgroundColor: '#2196f3',
                                  border: '2px solid gray',
                                  borderRadius: '5px',
                                }}
                              />
                            </div>
                            <div style={{marginTop: '40px', marginLeft: '350px'}}>
                              <input
                                type='submit'
                                className='btn btn-bg-primary'
                                onClick={handleUploadImage}
                              />
                            </div>
                            {/* 
                          {file && <img src={URL.createObjectURL(file)} alt="Uploaded Image" />} */}
                          </div>
                        </>
                      ) : (
                        ''
                      )}
                    </MDBRow>

                    {imageList ? (
                      <>
                        <table
                          className='table table-prop table-row-dashed table-row-gray-300 gy-7'
                          style={{}}
                        >
                          <thead>
                            <tr className='fw-bolder fs-6 text-gray-800'>
                              <th>Uploaded Image</th>
                            </tr>
                          </thead>
                          <tbody style={{}}>
                            <tr style={{}}>
                              {priviewImg.map((item) => (
                                <td style={{}}>
                                  <img
                                    style={{width: '200px', height: '200px'}}
                                    src={DISPLAY_IMAGE + item.property_image_path}
                                  />
                                </td>
                              ))}
                            </tr>
                          </tbody>
                        </table>
                      </>
                    ) : (
                      ''
                    )}

                    {/* <div className={classes.propertyGallery} >
565464
      </div> */}

                    <div className=' w-1  mt-15'>
                      <input
                        type='button'
                        value='Add Document'
                        className='btn btn-light-primary'
                        onClick={showDOc}
                        style={{padding: '10px', marginRight: '10px'}}
                      />
                    </div>
                  </MDBCol>
                </MDBRow>

                <MDBRow className={classes.docForm}>
                  {visible ? (
                    <div>
                      <div className='mb-10'>
                        <label className='form-label'>Document Type</label>
                        <select
                          className='form-select '
                          style={{width: '250px'}}
                          aria-label='Select example'
                          onChange={handleDocChange}
                        >
                          <option>select menu</option>
                          {getDoc.map((item) => (
                            <option
                              key={item.property_document_type_uuid}
                              value={item.property_document_type_uuid}
                            >
                              {item.property_document_type_name}
                            </option>
                          ))}
                        </select>
                        <div style={{width: '250px', marginTop: '-70px', marginLeft: '280px'}}>
                          <label className='form-label'>Document Name</label>
                          <input
                            type='text'
                            className='form-control'
                            placeholder='name'
                            onChange={handleNameChange}
                          />
                        </div>
                        <div style={{marginTop: '-40px', marginLeft: '600px'}}>
                          <input
                            type='file'
                            onChange={handleFileChange}
                            style={{
                              padding: '2px',
                              backgroundColor: '#2196f3',
                              border: '2px solid gray',
                              borderRadius: '5px',
                            }}
                          />
                          {/* {selectedFile && <div>Selected file: {selectedFile.name}</div>} */}
                        </div>

                        <div style={{marginTop: '40px', marginLeft: '350px'}}>
                          <input
                            type='submit'
                            role='button'
                            className='btn btn-bg-primary'
                            onClick={handleUpload}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                </MDBRow>

                {docList ? (
                  <>
                    <table className='table table-row-dashed table-row-gray-300 gy-7'>
                      <thead>
                        <tr className='fw-bolder fs-6 text-gray-800'>
                          <th>Document Name </th>
                          <th>Document Type </th>
                        </tr>
                      </thead>
                      <tbody style={{}}>
                        {previewDoc.map((item) => (
                          <tr key={item.property_document_uuid}>
                            <td>{item.property_document_type_name}</td>
                            <td>{item.document_label}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  ''
                )}

                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                  <button type='button' className='btn btn-bg-primary' onClick={handleSkip}>
                    Skip
                  </button>
                  <button
                    type='button'
                    style={{marginLeft: '20px'}}
                    className='btn btn-bg-primary'
                    onClick={handleSkip}
                  >
                    Home
                  </button>
                </div>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </form>
    </>
  )
}
export default Add_PropertyDocs
